import PropTypes from 'prop-types';
import { Icon, Modal, ModalHeader, ModalBody } from '@evertrue/et-components';
import { TASK_TYPES } from '../../../utils/cadence-step-utils';

/**
 * Modal for selecting a manual task type when adding a Manual Task step.
 * Shows a grid of task type options (Call, Email, Text, LinkedIn, etc.).
 */
const AddTaskTypeModal = ({ isOpen, onClose, onSelectTaskType }) => {
  const handleSelect = (taskType) => {
    onSelectTaskType(taskType);
    onClose();
  };

  return (
    <Modal isOpen={isOpen} closeModal={onClose} size="small">
      <ModalHeader title="Choose Task Type" closeModal={onClose} />
      <ModalBody>
        <div className="add-task-type-modal">
          <div className="add-task-type-modal--grid">
            {TASK_TYPES.map((taskType) => (
              <button
                key={taskType.id}
                type="button"
                className="add-task-type-modal--option"
                onClick={() => handleSelect(taskType)}
              >
                <div className="add-task-type-modal--icon">
                  <Icon icon={taskType.icon} />
                </div>
                <span className="add-task-type-modal--label">{taskType.label}</span>
              </button>
            ))}
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

AddTaskTypeModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSelectTaskType: PropTypes.func.isRequired,
};

export default AddTaskTypeModal;
